import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";

const ORDERS = [
  { name: "Riya", city: "Delhi", item: "wedding invitation suite", time: "2 minutes ago" },
  { name: "Aarav", city: "Mumbai", item: "corporate business cards", time: "8 minutes ago" },
  { name: "Tara", city: "Gurgaon", item: "luxury packaging boxes", time: "14 minutes ago" },
  { name: "Karan", city: "Bengaluru", item: "thank-you card set", time: "21 minutes ago" },
  { name: "Sneha", city: "Hyderabad", item: "save-the-date cards", time: "32 minutes ago" },
  { name: "Vikram", city: "Noida", item: "express letterhead order", time: "45 minutes ago" },
  { name: "Aditi", city: "Pune", item: "wedding e-invite suite", time: "1 hour ago" },
  { name: "Ravi", city: "Jaipur", item: "premium packaging tags", time: "1 hour ago" },
];

export default function LiveOrderFeed() {
  const [i, setI] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Initial show after 9s (after popup dismissed)
    const initial = setTimeout(() => setVisible(true), 9000);
    return () => clearTimeout(initial);
  }, []);

  useEffect(() => {
    if (!visible) return;
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setI((p) => (p + 1) % ORDERS.length);
        setVisible(true);
      }, 600);
    }, 7000);
    return () => clearInterval(cycle);
  }, [visible]);

  if (!visible) return null;

  const o = ORDERS[i];

  return (
    <div
      data-testid="live-order-feed"
      className="fixed bottom-20 md:bottom-7 left-4 md:left-7 z-40 flex items-center gap-2 md:gap-3 bg-[#1F1218] border border-[#3A2530] pl-2 pr-3 md:pr-5 py-1.5 md:py-2 max-w-[calc(100vw-2rem)] md:max-w-xs shadow-lg"
      style={{ animation: "slideUp 0.6s cubic-bezier(.16,1,.3,1)" }}
    >
      <span className="w-8 h-8 md:w-9 md:h-9 bg-[#F0C4BC]/10 border border-[#F0C4BC]/30 flex items-center justify-center flex-shrink-0">
        <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#F0C4BC]" />
      </span>
      <div className="leading-tight min-w-0">
        <p className="text-[11px] md:text-[12px] text-[#F8EDE7] truncate">
          <span className="font-medium">{o.name}</span> from <span className="font-medium">{o.city}</span>
        </p>
        <p className="text-[10px] md:text-[11px] text-[#C4A8B0] mt-0.5 truncate">
          ordered {o.item} · {o.time}
        </p>
      </div>
      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
